import React, { createContext } from 'react'
import { useDispatch } from 'react-redux';

import {
  WEB_SOCKET_URL
} from 'shared/utils/Constants';

const WebSocketContext = createContext(null)

export { WebSocketContext }

class Connection {
  constructor(url) {
    this.url = url;
  }

  connect() {
    this.socket = new WebSocket(this.url);
  }
}

export default ({ children }) => {
  //const dispatch = useDispatch();

  const conn = new Connection(WEB_SOCKET_URL);

  return (
    <WebSocketContext.Provider value={{ conn }}>
      {children}
    </WebSocketContext.Provider>
  )
}
